import { Package, TramFront, Truck } from 'lucide-react';
import type { Quantity } from '~/graphql/graphql';
import type { TransportMode } from '~/hooks/useTransportState';
import { formatQuantityForUnit } from '~/utils';

type VehiclePayloadLabelProps = {
  quantity: Quantity;
  vehicleLabel: TransportMode;
  piecesCount?: number;
};

export function VehiclePayloadLabel({
  quantity,
  vehicleLabel,
  piecesCount,
}: Readonly<VehiclePayloadLabelProps>) {
  if (quantity.value <= 0) return null;

  const showPieces =
    piecesCount != null && piecesCount > 0 && quantity.unit !== 'PCS';

  return (
    <p
      data-testid="vehicle-payload-label"
      className="text-xs text-neut-sec mt-1 flex items-center gap-1"
    >
      {
        {
          truck: <Truck size={12} aria-hidden="true" />,
          railcar: <TramFront size={12} aria-hidden="true" />,
          container: <Package size={12} aria-hidden="true" />,
        }[vehicleLabel]
      }
      {formatQuantityForUnit(quantity)} {quantity.unit}/{vehicleLabel}
      {showPieces && (
        <span className="text-neut-400"> ({Math.floor(piecesCount!)} PCS)</span>
      )}
    </p>
  );
}
